import { Slugs } from '@thinkalpha/common/constants/slugs.js';
import { FieldTypeCategory } from '@thinkalpha/language-services';
import type { TemplateColumn } from '@thinkalpha/ui-types/contracts/column-template';
import { registerClientColumn } from 'src/features/clientColumns';
import type { ClientColumnDefinition } from 'src/features/clientColumns';
import OrderSideGridCell from 'src/features/legsHoverCard/OrderSideGridCell.svelte';
import { generateDefaultDisplaySetting } from 'src/routes/dashboard/widget-container/widget-settings-editor/context';
import { v4 } from 'uuid';

/** The clientKey for the Order Side column type */
export const ORDER_SIDE_CLIENT_KEY = 'orderSide';

/**
 * Creates a new Order Side client column for use in column templates.
 * This column displays the order side value with an info icon for MULTI orders
 * that triggers the legs hover card.
 */
export function createOrderSideClientColumn(): TemplateColumn {
    return {
        id: v4(),
        name: 'Side',
        type: 'client',
        clientKey: ORDER_SIDE_CLIENT_KEY,
        dataType: FieldTypeCategory.String,
        unit: null,
        visible: true,
        displaySettings: [generateDefaultDisplaySetting()],
    };
}

/**
 * Client column definition for Order Side.
 * This is registered with the clientColumnRegistry.
 */
export const orderSideClientColumnDefinition: ClientColumnDefinition = {
    clientKey: ORDER_SIDE_CLIENT_KEY,
    displayName: 'Side',
    tableKey: 'orders',
    requiredSlugs: [Slugs.orderSide, Slugs.orderClOrdId],
    createGridCell: ({ resolvedFieldIds }) => ({
        component: OrderSideGridCell,
        props: {
            sideFieldId: resolvedFieldIds?.[Slugs.orderSide] ?? '',
            clOrdIdFieldId: resolvedFieldIds?.[Slugs.orderClOrdId] ?? '',
        },
    }),
    createColumn: createOrderSideClientColumn,
};

/**
 * Register the Order Side client column with the registry.
 * This should be called during application initialization.
 */
export function registerOrderSideClientColumn(): void {
    registerClientColumn(orderSideClientColumnDefinition);
}
